import { useParams } from 'react-router-dom'
import { AdminTitle } from '../../../../store/reducers/site';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateShopContactByTrn ,getShopCntInfoBytrns} from "../../../../store/actions/shopAction";
import { errorHelper, Loader } from '../../../../utils/tools';
import { validationContInfo, formContInfo } from './shopValidationSchema';
import { useFormik, FieldArray, FormikProvider } from 'formik';
import Divider from '@mui/material/Divider' ;
import TextField from '@mui/material/TextField';



import {
  
    Button,
    ButtonGroup
  

} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';


const EditShopCntInfo = () => {
    let { id } = useParams();
    
   
    // redux
    const shop = useSelector(state=>state.shopReducer);
    const users = useSelector(state=>state.users)
    const dispatch = useDispatch();

     // redux
    const [formData,setFormData] = useState(formContInfo)
    const [loading,setLoading] = useState(true);
     
     

    
    let navigate = useNavigate();
    let imgUrl='/dashboard/shop/timming/'+id;

   

    const formik = useFormik({
        enableReinitialize:true,
        initialValues: formData,
        validationSchema:validationContInfo,
        onSubmit:(values)=>{
           
            let myArray = id.split("_");
       
 
            let id1= Number(myArray[0]);
            let trns= Number(myArray[1]);
           
            console.log("111111111111111");
            console.log(values)
            console.log(id1)
            
            console.log("666666666666666666");
            values.shopId=id1;
          
            values.trsnNo=trns;
            console.log("111111111111111");
           
            
            console.log("666666666666666666");
           
            

            dispatch(updateShopContactByTrn(values))
            .unwrap()
            .then((response)=>{
       
                if(response!=null)
                {
                  
                    if(response.status==='ok')
                    {
                   //const id=response.id

                   console.log("55555555");
                   console.log(response)
                   //console.log(id)
                   
                   console.log("666666666666666666");
                
                  
                 navigate(`/dashboard/shop/editcntinfo/${id1}`)
                    }
                }


                
            })
        }
    })

   


   
  

    useEffect(()=>{
        
    
        dispatch(getShopCntInfoBytrns(id))
        .unwrap()
          .then(response => {
  
               setLoading(false);
if( response!==null){
    console.log("55555555");
    console.log(response)
    //console.log(id)
    
    console.log("666666666666666666");
 
                     
                      
         setFormData(response[0]);
        
                      }
  })
          
      },[id,dispatch])
     
  
   

    return(
        <>
        
        <AdminTitle title="Edit Contact Information"/>
        <form className='mt-3 news_form' onSubmit={formik.handleSubmit}>

        <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="title"
                    label="Title"
                    variant="outlined"
                    {...formik.getFieldProps('title')}
                    {...errorHelper(formik,'title')}
                    


                  
                   
                />
            </div>

            <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="email"
                    label="Email "
                    variant="outlined"
                    {...formik.getFieldProps('email')}
                    {...errorHelper(formik,'email')}


                  
                   
                />
            </div>

           

            <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="mobileNo"
                    label="ENTER YOUR MOBILE NUMBER "
                    variant="outlined"
                    {...formik.getFieldProps('mobileNo')}
                    {...errorHelper(formik,'mobileNo')}
                />
            </div>

                    

           
            
            <Divider className='mt-3 mb-3'/>
          
          
            { shop.loading ?
                    <Loader/>
                :
                <Button
                    variant='contained'
                    color="primary"
                    type="submit"
                >
                    Add Contact
                </Button>
                }

        </form>

        <div className='form-group'></div>
        <ButtonGroup className='me-2'>
                    <LinkContainer to={imgUrl}>
                        <Button 
                        variant='link'
                        color="orange"
                        >
                            Next
                            </Button>
                    </LinkContainer>
                </ButtonGroup>
       

        </>
    )

}

export default EditShopCntInfo;